import { makeStyles } from '@material-ui/styles';
import { DefaultTheme } from '@material-ui/styles';

const useStyles = makeStyles<DefaultTheme>({
    view_horizon_plasticity: {
        width: '100%',
        marginBottom: '20px !important',
        backgroundColor: 'transparent',
    },
    view_horizon_plasticity_title: {
        backgroundColor: 'transparent',
    },
    text_horizon_plasticity: {
        fontFamily: 'serca-condensed-text',
        letterSpacing: 1,
        fontSize: 16,
        color: "#000000",
        fontWeight: "bold",
        textAlign: "center"
    },
    view_horizon_plasticity_subtitle: {
        flexDirection: 'column',
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    text_horizon_plasticity_subtitle: {
        flexDirection: 'row',
        backgroundColor: 'transparent',
        alignItems: 'center',
    },
    view_horizon_plasticity_content: {
        width: '100%',
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    picker_select_type: {
        padding: '10px 20px !important',
        width: '300px',
        display: 'flex',
        justifyContent: 'center',
        borderRadius: 15,
        backgroundColor: 'transparent',
        '& fieldset.MuiOutlinedInput-notchedOutline': {
            borderColor: '#06617c !important',
        }
    },
    picker_select_item: {
        color: '#000',
        backgroundColor: 'transparent',
        width: '100%',
        alignItems: 'center',
        textAlign: 'center',
        fontFamily: 'serca-condensed-text',
        fontSize: 16,
    },
});

export default useStyles;